<script lang="ts" setup>
import TextButton from "@/shared/components/TextButton/TextButton.vue";
import Tooltip from "@/shared/components/Tooltip/Tooltip.vue";

defineProps<{
  text: string;
  title?: string;
  isToggletip?: boolean;
  showInfoText?: string;
}>();
</script>

<template>
  <Tooltip
    :text="text"
    :title="title"
    :is-toggletip="isToggletip"
  >
    <TextButton
      icon="info"
      icon-position="icon-only"
      :icon-size="20"
      :caption="
        showInfoText ? showInfoText : $t('shared.action.show.information')
      "
    />
  </Tooltip>
</template>
